import { QUIZ_CATEGORIES } from "~/constants/questionnaire";

import { SYMPTOMS_LIST_QUESTION } from "./constants";

export const LIVE_FEEDBACK_MESSAGE_TEMPLATE = "90% that choose {{answer}} saw improvement after 4–10 weeks";

export const isLiveFeedbackQuestion = (
    surveyCategory: string,
    questionName: string
) => {
    return surveyCategory === QUIZ_CATEGORIES.BIOIDENTICAL_HRT &&
        questionName === SYMPTOMS_LIST_QUESTION;
};
